import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const LEContactPhoneExt = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name="institutionContactInfo.leContactPhoneExt"
      control={control}
      render={({ field }) => (
        <FF2 label="Ext." field={field} input={(props) => <TextInput {...props} maxLength={6} />} />
      )}
    />
  )
}
